import $ from 'jquery';

$.fn.extend({
  brokerPhotosCollection() {
    this.each((idx, el) => {
      const $container = $(el);

      let $itemToDelete = $();

      const triggerFileInput = function triggerFileInput({ type, showDropdown = true }) {
        const $oldItem = $container.find(`.ui.upload.box.has-image input[name$="[type]"][value="${type}"]`).closest('[data-form-collection="item"]');

        const $vacantItem = $container.find('.ui.upload.box:not(.has-image)').closest('[data-form-collection="item"]');

        $vacantItem.find('input[name$="[type]"]').val(type);

        const $fileInput = $vacantItem.find('input[name$="[file]"]');

        $fileInput.on('change', () => {
          $vacantItem.find('.ui.upload.box').css({ display: 'block' });
          if (showDropdown) {
            $vacantItem.find('.ui.dropdown.to-cut-or-not-to-cut').css({ display: 'inline-block' });
          }
          $vacantItem.siblings().find('.ui.upload.box').css({ display: 'none' });
          $vacantItem.siblings().find('.ui.dropdown.to-cut-or-not-to-cut').css({ display: 'none' });

          $itemToDelete = $oldItem;
        });

        $fileInput.click();
      };

      $container.on('click', '.ui.dropdown.to-cut-or-not-to-cut .menu > .item.precut, .ui.dropdown.to-cut-or-not-to-cut .menu > .item.needs-cut', (evt) => {
        const $clicked = $(evt.currentTarget);
        const needsCut = $clicked.hasClass('needs-cut');
        const type = needsCut ? 'uncut' : 'cut';

        triggerFileInput({ type });
      });
      $container.on('click', '.button.go-precut', () => {
        triggerFileInput({ type: 'cut', showDropdown: false });
      });
      $container.on('click', '.button.go-needs-cut', () => {
        triggerFileInput({ type: 'uncut', showDropdown: false });
      });

      $container.find('.ui.dropdown.to-cut-or-not-to-cut').dropdown();
      $(document).on('collection-form-add', (evt, $addedElement) => {
        if ($.contains($container[0], $addedElement[0])) {
          $addedElement.find('.ui.dropdown.to-cut-or-not-to-cut').dropdown();
        }
      });
      $container.find('[data-form-collection="add"]').click();

      $container.closest('form').on('submit', (evt) => {
        if ($itemToDelete.length === 0) {
          return;
        }

        evt.preventDefault();

        const $form = $(evt.currentTarget);

        const $deleteButton = $itemToDelete.find('[data-form-collection="delete"]');

        $(document).on('collection-form-delete', (event, $button) => {
          if ($button.closest('[data-form-collection="item"]').find('.ui.upload.box').attr('id') === $deleteButton.closest('[data-form-collection="item"]').find('.ui.upload.box').attr('id')) {
            $itemToDelete = $();
            $form.submit();
          }
        });
        $deleteButton.click();
      });
    });
  },
});
